import { DownOutlined } from '@ant-design/icons';
import { Badge, Col, Dropdown, Layout, MenuProps, Popover, Row, Typography } from 'antd';
import { BellIcon } from 'assets/images';
import { CAvatar, CSelect } from 'components';
import { useAppAuth } from 'providers/app-auth';
import { useAppLanguage } from 'providers/app-language';
import { useAppPopup } from 'providers/app-popup';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate, useNavigate } from 'react-router-dom';
import { Logout, getProfile, getProperty, useLogout } from 'service/auth';
import { useGetNotifications } from 'service/notification';
import styled from 'styled-components';
import tw from 'twin.macro';
import NotificationContent from './notification';

const Header = () => {
  const { t } = useTranslation();
  const { translationObject } = useAppLanguage();
  const [open, setOpen] = useState(false);

  const handleOpenChange = (newOpen: boolean) => {
    setOpen(newOpen);
  };

  const { data } = useGetNotifications();
  const property = getProperty();

  const name = property ? translationObject({ object: property, keys: ['name'] }).name : undefined;

  const Icon = BellIcon;

  return (
    <Layout.Header style={{ backgroundColor: '#900c0c', height: 70 }}>
      <Row align="middle" className="w-full !h-full" justify="space-between">
        <Col>
          <Typography.Title ellipsis={{ tooltip: name }} className="!text-white" level={3}>
            {name}
          </Typography.Title>
        </Col>
        <Col>
          <Row>
            <Col className="center">
              <Popover
                placement="bottomLeft"
                title={<div className="bg-gray rounded-t-[10px] p-[13px] -mb-[8px]">{t('alert')}</div>}
                content={<NotificationContent open={open} setOpen={setOpen} />}
                trigger="click"
                overlayInnerStyle={{ padding: 0 }}
                overlayStyle={{ width: '370px' }}
                open={open}
                onOpenChange={handleOpenChange}
              >
                <Badge count={data?.countUnread || 0} offset={[0, 5]} overflowCount={99}>
                  <Icon height={30} width={30} className="cursor-pointer" />
                </Badge>
              </Popover>
            </Col>
            <Col className="!h-[70px] center ml-4">
              <TranslationBox />
            </Col>
            <Col className="!h-[70px] center ml-2 ">
              <UserBox />
            </Col>
          </Row>
        </Col>
      </Row>
    </Layout.Header>
  );
};

const CSelectStyle = styled(CSelect)`
  ${tw`flex justify-center`}
  height: 35px !important;
  width: 65px !important;
  border-radius: 50px !important;
  .ant-select-selector {
    border-radius: 50px !important;
    background-color: #ffffff2b !important;
    border: 1px solid #ffffff00 !important;
    color: white !important;
  }
  .ant-select-arrow {
    color: white !important;
    display: flex;
    align-items: center;
  }
  .ant-select-selection-item {
    color: white !important;
  }
`;

const TranslationBox = () => {
  const { lang, changeLanguage } = useAppLanguage();
  return (
    <CSelectStyle
      onChange={changeLanguage}
      valueOption={{
        valueKey: 'value',
        labelKey: 'label',
        values: [
          { value: 'en', label: 'EN' },
          { value: 'th', label: 'TH' },
        ],
      }}
      value={lang}
    />
  );
};

const UserBox = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { userMe } = useAppAuth();
  const { mutate } = useLogout();
  const { fireNotification } = useAppPopup();

  const onLogout = () => {
    const profileData = getProfile();
    mutate(
      {
        refreshToken: profileData?.refreshToken,
      },
      {
        onSuccess: () => {
          Logout();
        },
        onError: ({ message }: any) => {
          fireNotification({ type: 'error', message: message });
        },
      }
    );
  };

  const items: MenuProps['items'] = [
    {
      label: <div onClick={() => navigate(`/user-management/${userMe?.id}`)}>{t('profile')}</div>,
      key: '1',
    },
    {
      label: (
        <div
          onClick={() => {
            onLogout();
            return <Navigate to="/login" replace />;
          }}
        >
          {t('log-out')}
        </div>
      ),
      key: '0',
    },
  ];

  return (
    <Dropdown
      getPopupContainer={(e) => e}
      overlayStyle={{ width: 200, top: 50 }}
      trigger={['click']}
      placement="bottomRight"
      arrow
      menu={{ items }}
    >
      <div onClick={(e) => e.preventDefault()}>
        <ProfileBox />
      </div>
    </Dropdown>
  );
};

const ProfileBox = () => {
  const { translationObject } = useAppLanguage();
  const { userMe } = useAppAuth();

  const { title } = translationObject({
    object: userMe,
    keys: ['role.title'],
  });

  return (
    <Row className={` cursor-pointer w-[240px]`}>
      <Col span={6} className="center">
        <CAvatar src={userMe?.profilePicture?.url} size="large" style={{ border: '2px solid white' }} />
      </Col>
      <Col span={16} className="flex flex-col justify-center">
        <Typography.Text
          className="!text-white !text-[18px] "
          ellipsis={{ tooltip: `${userMe?.firstName} ${userMe?.lastName}` }}
        >
          {userMe?.firstName} {userMe?.lastName}
          <div className="text-white text-[12px]">{title}</div>
        </Typography.Text>
      </Col>
      <Col span={2}>
        <DownOutlined className="!text-white" style={{ fontSize: 12 }} />
      </Col>
    </Row>
  );
};

export default Header;
